<template>
  <img
    v-if="imageUrl && !imageLoadFailed"
    class="employee-seal"
    :src="imageUrl"
    :width="size"
    :height="size"
    :alt="name ? `${name} 社員印` : '社員印'"
    crossorigin="anonymous"
    @error="imageLoadFailed = true"
  >
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  imageUrl: {
    type: String,
    default: ''
  },
  size: {
    type: Number,
    default: 38
  }
});

const imageLoadFailed = ref(false);

watch(() => props.imageUrl, () => {
  imageLoadFailed.value = false;
});
</script>

<style scoped>
.employee-seal {
  display: block;
  flex: 0 0 auto;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  object-fit: contain;
}
</style>
